import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../../generic/FieldProps';
import { BirthRegistrationNumberInput } from './BirthRegistrationNumberInput';

export function BirthRegistrationNumberField<TValues extends FieldValues>({
  name,
  required = false,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return (
    <BirthRegistrationNumberInput
      value={value as string}
      onChange={onChange}
      required={required}
    />
  );
}
